/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  Card,
  message,
  Image,
  Button,
  Input,
  Radio,
  Row,
  Col,
  Upload,
} from 'antd';
import HlsJsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer';
import { screenShotAndUpload } from '@/utils/videoShotUtil';
import { UploadOutlined } from '@ant-design/icons';
import { putObject } from '@/utils/upload';

const ModalVideo = (props) => {
  const {
    src,
    visible,
    onCancel,
    visualModel,
    setVisualModel,
    onlyShow = true,
    onSubmit,
  } = props;
  const ref = useRef();
  const [player, setPlayer] = useState();

  useEffect(() => {
    if (visible) {
      playVideo();
    } else {
      player?.pause();
      player?.destroy();
    }
  }, [ref, src, visible, onlyShow]);

  function createPlayerConfig() {
    return {
      id: 'player',
      url: src,
      autoplay: true,
      playbackRate: [0.5, 0.75, 1, 1.5, 2],
      muted: true,
      screenShot: {
        saveImg: true,
        quality: 1,
        type: 'image/png',
        format: '.png',
      },
      cssFullscreen: true, // 网页样式全屏
      fluid: true,
      enableContextmenu: true, // 右键菜单
      volume: 0.0,
    };
  }

  const playVideo = () => {
    if (!src) {
      message.warn('视频URL为空！');
      return;
    }
    setTimeout(function () {
      // eslint-disable-next-line react/prop-types
      if (src.toLowerCase().endsWith('.m3u8')) {
        // eslint-disable-next-line no-new
        const player = new HlsJsPlayer(createPlayerConfig());
        setPlayer(player);
      } else {
        // eslint-disable-next-line no-new
        const player = new Player(createPlayerConfig());
        setPlayer(player);
      }
    }, 100);
  };

  const screenShotClick = () => {
    // screenShot(document, player);
    screenShotAndUpload(
      document,
      player?.video,
      (e) => {},
      (d) => {
        setVisualModel((current) => {
          const copy = { ...current };
          copy.trainUrl = d?.url;
          return copy;
        });
      },
    );
  };
  const onInputChange = (e) => {
    setVisualModel((current) => {
      const copy = { ...current };
      copy.name = e.target.value;
      return copy;
    });
  };
  const onVisualChange = (e) => {
    setVisualModel((current) => {
      const copy = { ...current };
      copy.visual = e.target.value;
      return copy;
    });
  };
  const onNodeChange = (e) => {
    setVisualModel((current) => {
      const copy = { ...current };
      copy.node = e.target.value;
      return copy;
    });
  };

  /**
   * 图片上传
   */
  const maxSize = 2 * 1024 * 1024;

  const customRequest = ({ file, onProgress, onError, onSuccess }) => {
    if (maxSize && file.size > maxSize) {
      message.warn(
        '图片大小不能超过' + Math.floor(maxSize / (1024 * 1024)) + 'M',
      );
      return;
    }

    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
    const types = ['PNG', 'JPG', 'JPEG', 'GIF'];
    if (!types.includes(fileType.toUpperCase())) {
      message.warn('不支持此类型文件！');
      return;
    }
    putObject({
      filename: file.name,
      file,
      onProgress,
      callback: (err, data) => {
        if (err) {
          onError(err);
        }
        if (data) {
          const d = {
            percent: 1,
            name: file.name,
            thumbUrl: `https://${data.Location}`,
            url: `https://${data.Location}`,
          };
          onSuccess(data, file);
          setVisualModel((current) => {
            const copy = { ...current };
            copy.trainUrl = d?.url;
            return copy;
          });
        }
      },
    });
  };
  const [fileList, setFileList] = useState([]);
  const props1 = {
    fileList,
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
      // 打设置可以查看进度
      // setFileList([...info.fileList]);
    },
    progress: {
      strokeColor: {
        '0%': '#108ee9',
        '100%': '#87d068',
      },
      strokeWidth: 3,
      format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
    },
    customRequest: customRequest,
  };

  return (
    <Modal
      destroyOnClose
      title={'视频详情'}
      width={800}
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Card bordered={false} bodyStyle={{ padding: 0 }}>
        <div id="player"></div>
        <div hidden={onlyShow} direction="vertical">
          <Row style={{ width: '100%' }}>
            <Col span={8}>
              <div
                style={{
                  marginTop: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: 10,
                }}
              >
                视角截图:(可暂停截图)
                <Image
                  // hidden={!trainUrl}
                  width={'150px'}
                  // height={'150px'}
                  src={visualModel?.trainUrl}
                ></Image>
                <Button
                  style={{ width: 150, marginTop: 10 }}
                  type="primary"
                  onClick={() => screenShotClick()}
                >
                  截图
                </Button>
                <Upload
                  {...props1}
                  accept={'.png, .jpg, .jpeg, .gif'}
                  maxCount={1}
                  multiple={false}
                  // customRequest={customRequest}
                >
                  <Button
                    style={{ width: 150, marginTop: 10 }}
                    type="primary"
                    icon={<UploadOutlined />}
                  >
                    本地上传
                  </Button>
                </Upload>
              </div>
            </Col>

            <Col span={12}>
              <div
                style={{
                  marginTop: 20,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div
                  style={{
                    marginTop: 10,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  视角名称:
                  <Input
                    style={{ width: 250, marginTop: 10 }}
                    value={visualModel?.name}
                    onChange={onInputChange}
                  ></Input>
                </div>
                <div
                  style={{
                    marginTop: 10,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  动作视角:
                  <Radio.Group
                    disabled={visualModel?.id}
                    onChange={onVisualChange}
                    value={visualModel?.visual}
                    // style={{ marginTop: 10 }}
                  >
                    <Radio value={'POSITIVE'}>POSITIVE</Radio>
                    <Radio value={'SIDE'}>SIDE</Radio>
                    <Radio value={'BACK'}>BACK</Radio>
                  </Radio.Group>
                </div>
                <div
                  style={{
                    marginTop: 10,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  视角节点:
                  <Radio.Group
                    disabled={visualModel?.id}
                    onChange={onNodeChange}
                    // style={{ marginTop: 10 }}
                    value={visualModel?.node}
                  >
                    <Radio value={'START'}>START</Radio>
                    <Radio value={'KEY'}>KEY</Radio>
                    <Radio value={'MID'}>MID</Radio>
                    <Radio value={'END'}>END</Radio>
                  </Radio.Group>
                </div>
              </div>
            </Col>
            <Col span={4}>
              <Button
                style={{ width: 100, height: 100, marginTop: 80 }}
                type="primary"
                shape="circle"
                onClick={() => {
                  onSubmit();
                }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </div>
      </Card>
    </Modal>
  );
};

export default ModalVideo;
